import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { uniqBy } from 'lodash';
import { MasterClienteHomeCreateProfileService } from '../../service/master-cliente-home-create-profile.service';
import { MasterClienteViewPermissionsCreateProfileService } from './master-cliente-create-profile.service';

@Component({
  selector: 'app-master-cliente-create-profile',
  templateUrl: './master-cliente-create-profile.component.html',
  styleUrls: ['./master-cliente-create-profile.component.scss'],
  providers: [MasterClienteViewPermissionsCreateProfileService],
})
export class MasterClienteCreateProfileComponent implements OnInit {
  panelOpenState: any;
  profiles: any;
  roles: any[] = [];
  count: Array<any> = [];
  total: Array<number> = [];
  movementPermissions:any
  positionPermissions:any
  otherReportPermissions:any
  hasRelatoriosPermissionSelected: boolean = false;
  reportPermission:any

  @Output() filterProfile: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private dialogService: DialogBoxService,
    private _masterEditProfileService: MasterClienteViewPermissionsCreateProfileService,
    public serviceHome: MasterClienteHomeCreateProfileService,
  ) { }

  ngOnInit() {
    this.getPermissions();
  }

  getPermissions() {
    this._masterEditProfileService.getPermissions().subscribe(data => {
      data.forEach(element => {
        if (element.name == 'Relatorios') {
          this.movementPermissions = element.permissions.filter(p =>
            p.name?.startsWith('MOVEMENT')
          )
          this.positionPermissions = element.permissions.filter(p =>
            p.name?.startsWith('POSICAO') || p.name?.startsWith('POSITION')
          )
          this.otherReportPermissions = element.permissions.filter(p =>
            p.name?.startsWith('OTHER')
          )
        }
        if(element.name =='Permissões de relatório'){
          this.reportPermission = element.permissions.filter(p => p.name ==='Relatórios');
          }
        element.permissions.forEach(permission => {
          if (!permission.checked) {
            permission.checked = false
            this.roles.push(permission)
          }
        })

     
      })
      this.profiles = data
      const desiredOrder = [
        'Permissões de sistema',
        'Permissões de operação',
        'Permissões de relatório',
        'Relatorios',
      ]
      if (this.profiles) {
        this.profiles.sort((a, b) => {
          const indexA = desiredOrder.indexOf(a.name)
          const indexB = desiredOrder.indexOf(b.name)
          return indexA - indexB
        })
      }
    })
  }
  onRelatoriosSelectionChanged(isSelected: boolean) {
    this.hasRelatoriosPermissionSelected = isSelected;
    if (!isSelected) {
      // Clear all report permissions
      this.clearAllReportPermissions();
    }
  }
  clearAllReportPermissions() {
    // Helper function to uncheck permissions
    const uncheckPermissions = (permissions) => {
      if (permissions) {
        permissions.forEach(p => p.checked = false);
        this.checkDataTable(permissions); // Update the roles array
      }
    };
  
    // Uncheck all report permissions
    uncheckPermissions(this.movementPermissions);
    uncheckPermissions(this.positionPermissions);
    uncheckPermissions(this.otherReportPermissions);
  
    // Force update the view
    this.movementPermissions = [...this.movementPermissions];
    this.positionPermissions = [...this.positionPermissions];
    this.otherReportPermissions = [...this.otherReportPermissions];
  }

  checkDuplicateValues() {
    this.roles = uniqBy(this.roles, 'id');
  }

  checkDataTable(e) {
    // e.map(ele => {
    //   this.roles.push(ele);
    // });
        // Filter out any undefined/null entries
  const validEntries = e.filter(item => item !== null && item !== undefined);
  
  // Add new checked roles or update existing ones
  validEntries.forEach(element => {
    const existingIndex = this.roles.findIndex(r => r.id === element.id);
    if (element.checked) {
      if (existingIndex === -1) {
        this.roles.push(element);
      } else {
        this.roles[existingIndex] = element;
      }
    } else {
      if (existingIndex !== -1) {
        this.roles.splice(existingIndex, 1);
      }
    }
  });
    this.checkDuplicateValues();
    this.countChecked(e);
  }

  countChecked(e) {
    this.count.push(e);
    const count = this.count
      .map(ar => JSON.stringify(ar))
      .filter((itm, idx, arr) => arr.indexOf(itm) === idx)
      .map(str => JSON.parse(str));

    this.total = count.map(roles => {
      return roles.filter((role: any) => role.checked == true).length;
    });
  }

  async validateNamePermission(name: string) {
    this.dialogService.dismissSnackbar();
    const result = await this._masterEditProfileService
      .checkPermissionName({ name })
      .toPromise();
    if (name != undefined && name.trim().length > 0) {
      if (result && result.exists == true) {
        this.serviceHome.getMessageProfileNameDuplicated(name).showWarn();
      }
    }
  }
  
sumReportsSelected(arr1,arr2,arr3) {
  let combinedReportsArray = [...(arr1 || []), ...(arr2 || []), ...(arr3 || [])];
  let len = combinedReportsArray.length
  let numSelected = 0;
  if (combinedReportsArray !== null) {
    combinedReportsArray.forEach(elemeent => {
      if (JSON.parse(elemeent.checked) === true) {
        numSelected++;
      }
    });
  }
  let str = numSelected + "/"+len
  return str
}
getLength(arr: Array<any>) {
  if (arr !== null && arr !== undefined) {
    return arr.length;
  }
  return 0;
}
validateCheckedItems(): boolean {
  let isValid : boolean =false 
  const movementsValid = this.movementPermissions?.some(p => p.checked) ?? false;
  const positionsValid = this.positionPermissions?.some(p => p.checked) ?? false;
  const reportsValid = this.otherReportPermissions?.some(p => p.checked) ?? false;
  const reportPermission = this.reportPermission?.some(p => p.checked) ?? false;

  if(!reportPermission || (reportPermission && (movementsValid || positionsValid || reportsValid))){
    isValid =true
  } else{
    isValid=false
  }

  return isValid
}
}
